import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateBreadcrumbHref } from '~src/spacesPlatform/actions/UpdateBreadcrumbHref';
import { ConnectedContentTypeFilterUpdater } from '~src/spacesPlatform/components/Explorer/helpers/ContentTypeFilterUpdater';
import { ConnectedFilterUpdater } from '~src/spacesPlatform/components/Explorer/helpers/FilterUpdater';
import { ConnectedSortOrderUpdater } from '~src/spacesPlatform/components/Explorer/helpers/SortOrderUpdater';

import { MapDispatchToProps } from '../../utils/ConnectUtils';

export interface QueryParamUpdateProviderDispatchProps {
  readonly updateBreadcrumbHref: (url: string) => void;
}

export interface QueryParamUpdateProviderOwnProps {
  readonly shouldUpdateFilters: boolean;
  readonly shouldUpdateContentTypes: boolean;
  readonly shouldUpdateBreadcrumbs: boolean;
  readonly shouldUpdateSort: boolean;
  readonly routeLocationSearch: string;
  readonly routeLocationPath: string;
  readonly resetStore?: boolean;
}

export type QueryParamUpdateProviderProps = QueryParamUpdateProviderDispatchProps & QueryParamUpdateProviderOwnProps;

export class QueryParamUpdateProvider extends React.PureComponent<QueryParamUpdateProviderProps> {
  constructor(props: QueryParamUpdateProviderProps) {
    super(props);
    this.updateBreadcrumbHref();
  }

  public render() {
    // Set the base contents to the children of this component, and wrap with necessary updaters based on which props
    // are set.
    let contents = <>{this.props.children}</>;

    if (this.props.shouldUpdateFilters) {
      contents = (
        <ConnectedFilterUpdater {...this.props}>
          {contents}
        </ConnectedFilterUpdater>
      );
    }

    if (this.props.shouldUpdateSort) {
      contents = (
        <ConnectedSortOrderUpdater {...this.props}>
          {contents}
        </ConnectedSortOrderUpdater>
      );
    }

    if (this.props.shouldUpdateContentTypes) {
      contents = (
        <ConnectedContentTypeFilterUpdater {...this.props}>
          {contents}
        </ConnectedContentTypeFilterUpdater>
      );
    }

    return contents;
  }

  public componentDidUpdate(prevProps: QueryParamUpdateProviderProps) {
    if (prevProps.routeLocationPath !== this.props.routeLocationPath ||
          prevProps.routeLocationSearch === this.props.routeLocationSearch) {
      // only update the current breadcrumb in redux store when the query changes on the current path
      // There are some weird timing issue with redux and componentDidUpdate calls
      // if the route/path changes then those should be handled by Providers and children.
      // this is also why we don't update on mount.
      return;
    }

    this.updateBreadcrumbHref();
  }

  private updateBreadcrumbHref() {
    if (this.props.shouldUpdateBreadcrumbs) {
      this.props.updateBreadcrumbHref(window.location.href);
    }
  }
}

const mapDispatchToProps: MapDispatchToProps<QueryParamUpdateProviderDispatchProps> = (dispatch) => bindActionCreators({
  updateBreadcrumbHref
}, dispatch);

export const ConnectedQueryParamUpdateProvider: React.ComponentClass<QueryParamUpdateProviderOwnProps>
  = connect(null, mapDispatchToProps)(QueryParamUpdateProvider);
